module.exports = __webpack_public_path__ + "static/img/Checkout-structure-mockup-01.1799216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Checkout-structure-mockup-01.jpg
// module id = X7nx
// module chunks = 1